import React from 'react';
import PropTypes from 'prop-types';
import './Table.scss';

const EmptyRow = ({columnNumbers= 1, text}) => {
    return(
        <tr>
            <td
                colSpan={columnNumbers}
                className="empty-row">
                {text}
            </td>
        </tr>
    );
};

EmptyRow.propTypes = {
    columnNumbers: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired 
};

export default EmptyRow;


// WEBPACK FOOTER //
// ./src/components/base/Table/EmptyRow.js